const ipConfig = {
  api_mdt: process.env.VUE_APP_API_BASE_URL,
  api_mwclg: process.env.VUE_APP_API_MWCLG,
  api_basic: '//api.echem56.com/api-basic',
  api_storage: process.env.VUE_APP_API_STORAGE_URL,
  // api_shell: process.env.VUE_APP_TMS_URL,
  api_gateway: process.env.VUE_APP_API_GATEWAY,
  api_shell: process.env.VUE_APP_TMS_SHELL,
  //   api_shell: '//cors.mcpsystem.com/guest.mcpsystem.com',
  api_rms: process.env.VUE_APP_API_RMS,
  LOGINURL: process.env.VUE_APP_WEB_MWCLG + '/user-center/orderInquiry',
  // api_imgdown: 'api_imgdown'
  api_edi: process.env.VUE_APP_FMS_EDI,
  upload_oss_api: process.env.VUE_APP_UPLOAD_OSS_API,
  api_tankedi: process.env.VUE_APP_GMS_EDI,
  api_wms_report: process.env.VUE_APP_WMS_REPORT,
}
module.exports = ipConfig
